<style scoped>
.ipt-sty {
  width: 70% !important;
}
.search-detail-box {
  padding: 16px;
  margin-top: 8px;
  background: #fff;
}
.search-detail-title {
  display: flex;
  justify-content: space-between;
  text-align: left;
  font-size: 18px;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
  margin: 0;
  padding-bottom: 10px;
  border-bottom: 1px solid #cecece;
}
.person-detail {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  font-size: 12px;
  margin-bottom: 40px;
}
.person-detail-list {
  display: flex;
  width: 50%;
  line-height: 20px;
  margin-bottom: 10px;
}
.person-detail-name {
  width: 120px;
  text-align: right;
  flex-shrink: 0;
}
.search-detail-wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
}
.person-detail-rate {
  width: 100px;
  flex-shrink: 0;
}
.person-detail-rate p {
  font-size: 12px;
  margin-top: 0px;
}
.base-box-left {
  width: 410px;
  flex-shrink: 0;
  padding: 16px 24px 20px;
  background: #fff;
  box-sizing: border-box;
  /* border-right: 1px solid #f2f2f2; */
}
.base-box-right {
  width: calc(100% - 418px);
  padding: 16px 24px 20px;
  background: #fff;
  box-sizing: border-box;
}
.base-box-right .search-detail-title {
  border-bottom: none;
}
.base-box-right .search-detail-title span {
  display: inline-block;
  font-size: 14px;
  width: 64px;
  height: 32px;
  line-height: 32px;
  border-radius: 2px;
  text-align: center;
  color: #4a4a4a;
  font-weight: 300;
  margin-right: 7px;
  cursor: pointer;
  border: 1px solid #e2e2e2;
}
.person-title-box {
  margin: 17px 0;
}
.person-title-list {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
}
.person-title-list .person-name {
  font-size: 18px;
  color: #4a4a4a;
}
.person-title-list .person-rate {
  font-size: 24px;
  color: #f5a623;
}
.person-title-list .person-phone {
  font-size: 14px;
  color: #4a4a4a;
}
.person-title-list .person-rate-title {
  font-size: 12px;
  color: #9b9b9b;
}
.person-base-box {
  padding: 16px;
  box-sizing: border-box;
  background: #f6f6f6;
}
.person-base-list {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.person-base-item {
  display: flex;
}
.person-base-label {
  flex-shrink: 0;
}
.terminal-box {
  padding: 20px 24px;
  margin-top: 8px;
  box-sizing: border-box;
  background: #fff;
}
.terminal-title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 11px;
}
.terminal-title-left {
  display: flex;
  align-items: center;
  color: #4a4a4a;
}
.terminal-title-left p {
  font-size: 18px;
  font-weight: bold;
  margin: 0 32px 0 0;
}
.terminal-table-list {
  color: #8a8a8a;
  margin-right: 40px;
  cursor: pointer;
  position: relative;
}
.terminal-tab-active {
  color: #4a4a4a;
}
.terminal-tab-active::after {
  content: '';
  display: block;
  clear: both;
  position: absolute;
  width: 52px;
  height: 3px;
  bottom: -7px;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #63b6bd;
}
.terminal-title-right {
  font-size: 14px;
  width: 64px;
  height: 32px;
  line-height: 32px;
  border-radius: 2px;
  text-align: center;
  color: #4a4a4a;
  font-weight: 300;
  margin-right: 7px;
  cursor: pointer;
  border: 1px solid #e2e2e2;
}
.terminal-table-box{
  padding-bottom: 30px;
}
.el-col-9{
  display: flex;
}
.el-col-6{
  display: flex;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="9">
          <div class="search-area-div w110">药企名称：</div>
          <el-select v-model="page.tenantGuid" placeholder="请选择药企名称" class="ipt-sty w70f" @change="tenantChange" clearable filterable>
            <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName" :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="9">
          <div class="search-area-div w110">部门名称：</div>
          <el-select v-model="page.organisationGuid" placeholder="请选择部门名称" class="ipt-sty w70f" clearable filterable @change="organisationChange" @focus="getOrganisation()">
            <el-option v-for="item in organisationList" :key="item.guid" :label="item.organisationName" :value="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div w110">人员：</div>
          <el-select class="ipt-sty w70f" v-model="page.staffGuid" placeholder="请选择" filterable size="medium" v-loading="staffLoading" @focus="getStaffChange()">
            <el-option v-for="item in staffList" :key="item.guid" :label="item.staffName" :value="item.guid">
            </el-option>
          </el-select>
          <!-- <el-input v-model="page.staffName" class="ipt-sty w70f" placeholder="请输入姓名/手机号"></el-input> -->
        </el-col>
        <el-col :span="24" class="t-right mt15">
          <el-button size="medium" type="info" @click="searchDetail()">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="search-detail-wrap">
      <!-- 基本信息 -->
      <div class="base-box-left">
        <p class="search-detail-title">基本信息</p>
        <div class="person-title-box">
          <div class="person-title-list">
            <div class="person-name">{{ staffData.staffName || '-' }}</div>
            <div class="person-rate">{{avgScore.toFixed(1)}}</div>
          </div>
          <div class="person-title-list">
            <div class="person-phone">{{ staffData.mobileNo || '-' }}</div>
            <div class="person-rate-title">精准考核综合评分</div>
          </div>
        </div>
        <div class="person-base-box">
          <div class="person-base-list">
            <div class="person-base-item">
              <div class="person-base-label">出生年月：</div>
              <div class="person-base-content">{{ staffData.birthday | getDate }}</div>
            </div>
            <div class="person-base-item">
              <div class="person-base-label">性别：</div>
              <div class="person-base-content">
                {{ staffData.sex == 'F' ? '男' : staffData.sex == 'M' ? '女' : '-' }}
              </div>
            </div>
          </div>
          <div class="person-base-list">
            <div class="person-base-item w100f">
              <div class="person-base-label">年龄：</div>
              <div class="person-base-content">{{ staffData.age || '-' }}</div>
            </div>
          </div>
          <div class="person-base-list">
            <div class="person-base-item w100f">
              <div class="person-base-label">身份证号：</div>
              <div class="person-base-content">{{ staffData.idCode || '-' }}</div>
            </div>
          </div>
          <div class="person-base-list">
            <div class="person-base-item w100f">
              <div class="person-base-label">平台从业时间(天)：</div>
              <div class="person-base-content">{{ staffData.platformWorkingTime || '-'}}</div>
            </div>
          </div>
          <div class="person-base-list">
            <div class="person-base-item">
              <div class="person-base-label">擅长区域：</div>
              <div class="person-base-content">{{ staffData.adeptTerritory || '-' }}</div>
            </div>
            <div class="person-base-item">
              <div class="person-base-label">擅长领域：</div>
              <div class="person-base-content">{{ staffData.adeptDomain || '-' }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 行为信息 -->
      <div class="base-box-right">
        <p class="search-detail-title">行为信息<span @click="taskInfoExport">导出</span></p>
        <el-table :data="taskInfoTable.rowData" ref="table" border style="width: 100%" v-loading="taskInfoLoading" height="300">
          <!-- <el-table-column label="序号" width="60" header-align="center" align="center" v-if="taskInfoTable.columns">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column> -->
          <el-table-column :width="index == 0?80:130" :label="item" show-overflow-tooltip :header-align="index == 0?'center':'right'" :align="index == 0?'center':'right'" v-for="(item, index) in taskInfoTable.colName" :key="index">
            <template slot-scope="scope">
              <span v-if="index == 0">{{scope.row[index]}}</span>
              <span v-else>{{ scope.row[index]  | numDigit}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!-- 收入信息 -->
    <div class="search-detail-box">
      <!-- <p class="search-detail-title">收入信息</p> -->
      <div class="search-charts">
        <div id="myChart" ref="geoChart" style="width: 100%; height: 360px"></div>
      </div>
    </div>
    <!-- 终端资源信息 -->
    <div class="terminal-box">
      <div class="terminal-title-box">
        <div class="terminal-title-left">
          <p>终端资源信息</p>
          <div :class="tabIndex == index ? 'terminal-table-list terminal-tab-active' : 'terminal-table-list'" @click="tabChange(index)" v-for="(item, index) in tabList" :key="index">
            {{ item }}
          </div>
        </div>
        <div class="terminal-title-right" v-if="tabIndex == 0" @click="hospitalExport">导出</div>
        <div class="terminal-title-right" v-else @click="notHospitalExport">导出</div>
      </div>
      <!-- 医院资源 -->
      <div class="terminal-table-box" v-show="tabIndex == 0">
        <el-table :data="hospitalTable" style="width: 100%" height="520" v-loading="medLoading" border>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip min-width="150" header-align="center" align="left" prop="customerName" label="医院名称">
            <template slot-scope="scope">{{ scope.row.customerName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="100" header-align="center" align="left" prop="provinceName" label="所属省">
            <template slot-scope="scope">{{ scope.row.provinceName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="100" header-align="center" align="left" prop="cityName" label="所属市">
            <template slot-scope="scope">{{ scope.row.cityName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="100" header-align="center" align="left" prop="districtName" label="所属区县">
            <template slot-scope="scope">{{ scope.row.districtName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="100" header-align="center" align="left" prop="deptName" label="科室">
            <template slot-scope="scope">{{ scope.row.deptName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="100" header-align="center" align="left" prop="doctorName" label="医生">
            <template slot-scope="scope">{{ scope.row.doctorName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="80" header-align="center" align="left" prop="technicalTitles" label="职称">
            <template slot-scope="scope">{{ scope.row.technicalTitles || '-' }}</template>
          </el-table-column>
          <el-table-column width="80" header-align="center" align="left" prop="level" label="等级">
            <template slot-scope="scope">{{ scope.row.level || '-' }}</template>
          </el-table-column>
          <el-table-column width="110" header-align="center" align="center" prop="minTaskTime" label="最近拜访时间">
            <template slot-scope="scope">{{ scope.row.minTaskTime | getDate }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="110" header-align="center" align="center" prop="maxTaskTime" label="最早拜访时间">
            <template slot-scope="scope">{{ scope.row.maxTaskTime  | getDate }}</template>
          </el-table-column>
          <el-table-column width="80" header-align="center" align="right" prop="visitCount" label="拜访次数">
            <template slot-scope="scope">{{ scope.row.visitCount || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="110" header-align="center" align="right" prop="amount" label="订单金额(元)">
            <template slot-scope="scope">{{ scope.row.amount | numDigit }}</template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination> -->
      </div>
      <!-- 非医院资源 -->
      <div class="terminal-table-box" v-show="tabIndex == 1">
        <el-table :data="notHospitalTable" style="width: 100%" height="520" v-loading="hospitalLoading" border>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip min-width="150" header-align="center" align="left" prop="customerName" label="终端名称">
            <template slot-scope="scope">{{ scope.row.customerName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="100" header-align="center" align="left" prop="provinceName" label="所属省">
            <template slot-scope="scope">{{ scope.row.provinceName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="100" header-align="center" align="left" prop="cityName" label="所属市">
            <template slot-scope="scope">{{ scope.row.cityName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="100" header-align="center" align="left" prop="districtName" label="所属区县">
            <template slot-scope="scope">{{ scope.row.districtName || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="100" header-align="center" align="left" prop="districtName" label="终端类型">
            <template slot-scope="scope">{{ scope.row.customerType || '-' }}</template>
          </el-table-column>
          <el-table-column width="110" header-align="center" align="center" prop="minTaskTime" label="最近拜访时间">
            <template slot-scope="scope">{{ scope.row.minTaskTime | getDate }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="110" header-align="center" align="center" prop="maxTaskTime" label="最早拜访时间">
            <template slot-scope="scope">{{ scope.row.maxTaskTime  | getDate }}</template>
          </el-table-column>
          <el-table-column width="80" header-align="center" align="right" prop="visitCount" label="拜访次数">
            <template slot-scope="scope">{{ scope.row.visitCount || '-' }}</template>
          </el-table-column>
          <el-table-column show-overflow-tooltip width="110" header-align="center" align="right" prop="amount" label="订单金额(元)">
            <template slot-scope="scope">{{ scope.row.amount | numDigit }}</template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          class="pt pb back-color-fff"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 100, 200]"
          :current-page="page.pageIndex"
          :page-size="page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.totalRows"
        >
        </el-pagination> -->
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        page: {
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
          totalRows: 0,
          serviceTenantGuid: localStorage.guid,
          tenantGuid: null,
          organisationGuid: null,
          staffGuid: null,
        },
        taskInfoLoading: false,
        medLoading: false,
        hospitalLoading: false,
        timeLists: [],
        organisationList: [],
        tenantList: [],
        loading: false,
        tableData: [],
        staffLoading: false,
        staffList: [],
        staffData: null,
        tabList: ['医院资源', '非医院资源'],
        tableData: [],
        hospitalTable: [],
        notHospitalTable: [],
        taskInfoTable: [],
        tabIndex: 0,
        avgScore:0
      };
    },
    created() {
      if (sessionStorage.staffData) {
        this.staffData = JSON.parse(sessionStorage.staffData);
        this.page.tenantGuid = this.staffData.tenantGuid;
      }
      // 列表
      this.getChartData();
      this.getTenantList();
      this.getTaskInfo();
      this.getHospitalTable();
      this.getNotHospitalTable();
      this.getAvgScore();
    },
    methods: {
      //获取药企
      getTenantList() {
        let self = this;
        let query = {
          isService: true,
          tenantGuid: localStorage.guid,
        };
        self.api
          .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.tenantList = res.data.data;
              self.getOrganisationList(this.page.tenantGuid);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      //获取平均分
      getAvgScore() {
        let self = this;
        let staffGuid = this.page.staffGuid ? this.page.staffGuid : this.staffData.guid;
        self.api.get(`/${serverConfig.msSalesPerformService}/task-audit/staff/income-manage-score-avg?staffGuid=${staffGuid}`).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
             self.avgScore = Number(res.data.data);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      tabChange(index) {
        this.tabIndex = index;
      },
      //进度条格式化
      format(percentage) {
        return percentage;
      },
      tenantChange(val) {
        if (val) {
          this.getOrganisationList(val);
          this.getStaff();
        }
      },
      organisationChange(val) {
        if (val) {
          this.getStaff(1);
        }
      },
      getStaffChange(val) {
        if (!this.page.tenantGuid) {
          this.$message.error('请先选择药企！');
          return;
        }
      },
      //获取人员
      getStaff(type) {
        let self = this;
        if (!this.page.tenantGuid) {
          this.$message.error('请先选择药企！');
          return;
        }
        let query = {
          pageIndex: 1,
          pageSize: -1,
          bizState: 'Y',
          organisationGuid: this.page.organisationGuid,
          tenantGuid: this.page.tenantGuid,
        };
        this.staffLoading = true;
        // return new Promise((resolve, reject) => {
        self.api.postJson(`/${serverConfig.msPersonnelService}/staff/data/get`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.staffList = res.data.data.records;
            self.staffLoading = false;
            if (type == 1) {
              this.page.staffGuid = '';
            } else {
              this.page.staffGuid = this.staffData.guid;
            }

            // resolve();
          } else {
            self.$message.error(res.data.msg);
          }
        });
        // });
      },
      //行为信息
      getTaskInfo() {
        let self = this;
        let staffGuid = null;
        let tenantGuid = null;
        staffGuid = this.page.staffGuid ? this.page.staffGuid : this.staffData.guid;
        tenantGuid = this.page.tenantGuid ? this.page.tenantGuid : this.staffData.tenantGuid;
        self.taskInfoLoading = true;
        self.api
          .postJson(
            `/${serverConfig.msBizdataStatisticsService}/staff-task/staff/income/get-task-info?staffGuid=${staffGuid}&tenantGuid=${tenantGuid}`
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.taskInfoLoading = false;
              self.taskInfoTable = res.data.data;
              self.$nextTick(() => {
                self.$refs.table.doLayout()
              })
              console.log(self.$refs);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      //医院资源
      getHospitalTable() {
        let self = this;
        let staffGuid = null;
        let tenantGuid = null;
        staffGuid = this.page.staffGuid ? this.page.staffGuid : this.staffData.guid;
        tenantGuid = this.page.tenantGuid ? this.page.tenantGuid : this.staffData.tenantGuid;
        self.medLoading = true;
        self.api
          .postJson(
            `/${serverConfig.msBizdataStatisticsService}/staff-task/staff/income/get-med-info?staffGuid=${staffGuid}&tenantGuid=${tenantGuid}`
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.medLoading = false;
              self.hospitalTable = res.data.data;
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      //非医院资源
      getNotHospitalTable() {
        let self = this;
        let staffGuid = null;
        let tenantGuid = null;
        staffGuid = this.page.staffGuid ? this.page.staffGuid : this.staffData.guid;
        tenantGuid = this.page.tenantGuid ? this.page.tenantGuid : this.staffData.tenantGuid;
        self.hospitalLoading = true;
        self.api
          .postJson(
            `/${serverConfig.msBizdataStatisticsService}/staff-task/staff/income/get-customer-info?staffGuid=${staffGuid}&tenantGuid=${tenantGuid}`
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.hospitalLoading = false;
              self.notHospitalTable = res.data.data;
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      getStaffDetail(type) {
        let self = this;
        self.loading = true;
        let query = {
          serviceTenantGuid: localStorage.guid,
          tenantGuid: this.page.tenantGuid,
          organisationGuid: this.page.organisationGuid ? [this.page.organisationGuid] : [],
          staffGuid: this.page.staffGuid,
        };
        self.api.postJson(`/${serverConfig.msSalesPerformService}/task-audit/staff/income`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.loading = false;
            if (res.data.data.records) {
              self.staffData = res.data.data.records[0];
              this.getTaskInfo();
              this.getHospitalTable();
              this.getNotHospitalTable();
              this.getChartData();
            } else {
              self.$message.error('暂无此人员相关信息');
              self.staffData = {};
              self.taskInfoTable = {};
              self.hospitalTable = [];
              self.notHospitalTable = [];
              self.drawLine();
              self.taskInfoLoading = false;
              self.medLoading = false;
              self.hospitalLoading = false;
            }
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      searchDetail() {
        if (!this.page.tenantGuid) {
          this.$message.error('请选择药企！');
          return;
        }
        if (!this.page.staffGuid) {
          this.$message.error('请选择人员！');
          return;
        }
        this.getStaffDetail(1);

      },
      //获取组织
      getOrganisationList(tenantGuid) {
        let self = this;
        let query = {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid: tenantGuid,
        };
        self.page.organisationGuid = '';
        self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationList = res.data.data.records;
            self.page.organisationGuid = self.staffData.organisationGuids[0];
            self.getStaff();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      getOrganisation() {
        if (this.page.tenantGuid == '' || this.page.tenantGuid == null) {
          this.$message.error('请选择药企名称!');
          return;
        }
        this.page.staffGuid = '';
      },
      changeTab(index, item) {
        this.page.allocateState = item.value;
        this.activeTab = index;
        this.getData(1);
      },
      empty() {
        let self = this;
        self.page = {
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
          totalRows: 0,
          serviceTenantGuid: localStorage.guid,
          tenantGuid: null,
          organisationGuid: null,
          staffName: null,
        };
      },
      handleSizeChange(val) {
        let self = this;
        self.page.pageSize = val;
        //   this.getData();
      },
      handleCurrentChange(val) {
        let self = this;
        self.page.pageIndex = val;
        //   this.getData();
      },
      //行为信息-批量导出
      taskInfoExport() {
        let self = this;
        let staffGuid = null;
        let tenantGuid = null;
        staffGuid = this.page.staffGuid ? this.page.staffGuid : this.staffData.guid;
        tenantGuid = this.page.tenantGuid ? this.page.tenantGuid : this.staffData.tenantGuid;
        self.fullscreenLoading = true;
        self.api
          .postJson(
            `/${serverConfig.msBizdataStatisticsService}/staff-task/staff/income/export-task-info?staffGuid=${staffGuid}&tenantGuid=${tenantGuid}`,
          )
          .then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      //医院导出
      hospitalExport() {
        let self = this;
        let staffGuid = null;
        let tenantGuid = null;
        staffGuid = this.page.staffGuid ? this.page.staffGuid : this.staffData.guid;
        tenantGuid = this.page.tenantGuid ? this.page.tenantGuid : this.staffData.tenantGuid;
        self.fullscreenLoading = true;
        self.api
          .postJson(
            `/${serverConfig.msBizdataStatisticsService}/staff-task/staff/income/export-med-info?staffGuid=${staffGuid}&tenantGuid=${tenantGuid}`,
          )
          .then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      //非医院导出
      notHospitalExport() {
        let self = this;
        let staffGuid = null;
        let tenantGuid = null;
        staffGuid = this.page.staffGuid ? this.page.staffGuid : this.staffData.guid;
        tenantGuid = this.page.tenantGuid ? this.page.tenantGuid : this.staffData.tenantGuid;
        self.fullscreenLoading = true;
        self.api
          .postJson(
            `/${serverConfig.msBizdataStatisticsService}/staff-task/staff/income/export-customer-info?staffGuid=${staffGuid}&tenantGuid=${tenantGuid}`,
          )
          .then((res) => {
            self.fullscreenLoading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      reportJx(colNames, datas, sheetName, fileNam) {
        let self = this;
        self.api
          .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
            colNames: colNames,
            datas: datas,
            sheetName: sheetName,
            fileNam: fileNam,
          })
          .then((res) => {
            let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            let fileName = fileNam;
            let objectUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = fileName;
            link.href = objectUrl;
            link.click();
          });
      },
      //获取图表数据
      getChartData() {
        let staffGuid = null;
        let tenantGuid = null;
        staffGuid = this.page.staffGuid ? this.page.staffGuid : this.staffData.guid;
        tenantGuid = this.page.tenantGuid ? this.page.tenantGuid : this.staffData.tenantGuid;
        this.api
          .get(
            `/${serverConfig.msBizdataStatisticsService}/staff-task/staff/income/trend?staffGuid=${staffGuid}&tenantGuid=${tenantGuid}`,
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              let resData = res.data.data;
              if (resData) {
                let lateralAxis = resData.lateralAxis;
                lateralAxis.forEach((i, index) => {
                  lateralAxis[index] = i.substr(0, 4) + '-' + i.substr(4, 2)
                });
                console.log(lateralAxis)
                this.drawLine(lateralAxis, resData.datas[0]);
              } else {
                this.drawLine();
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
      },
      //图表渲染
      drawLine(xData, yData) {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'));
        let data = yData ? yData.values : [];
        let max = parseInt(Math.max.apply(null, data));
        console.log(data)
        if (data && data.length > 0) {
          data.forEach((i, index) => {
            data[index] = Number(i.toFixed(2));
          })
        }
        // 绘制图表
        myChart.setOption({
          title: { text: yData ? yData.name : '暂无收入信息' },
          tooltip: {},
          color: ['#A2D8D2'],
          xAxis: {
            data: xData,
          },
          dataZoom: [
            {
              show: true,
              realtime: true,
              start: 0,
              end: data.length < 13 ? 100 : (12 / data.length) * 100,
            },
            {
              type: 'inside',
              realtime: true,
              start: 0,
              end: data.length < 13 ? 100 : (12 / data.length) * 100,
            },
          ],
          yAxis: {
            name: '单位(元)',
            interval: max / 5
          },
          grid: {
            top: '80px',
            left: '100px',//距离左边距
            right: '100px',//距离右边距
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
            textStyle: {
              align: 'left',
            },
          },
          series: [
            {
              name: '收入(元)',
              type: 'bar',
              data: data,
              barMaxWidth: 100, //柱图宽度
              itemStyle: {
                normal: {
                  label: {
                    show: true, //开启显示
                    position: 'top', //在上方显示
                    textStyle: {
                      //数值样式
                      color: 'black',
                      fontSize: 12,
                    },
                    formatter: function (params) {
                      return String(params.data).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    },
                  },
                },
              },
            },
          ],
        });
        myChart.on('click', (params) => {
          let staffData = JSON.parse(JSON.stringify(this.staffData));
          staffData.accountMonth = params.name;
          sessionStorage.removeItem('staffData');
          this.$router.push({
            path: '/checkTaskList',
            productGuid:this.$route.query.productGuid
            
          });
          sessionStorage.setItem('staffData', JSON.stringify(staffData));
          sessionStorage.setItem('staffDataDetail', JSON.stringify(staffData));
        });
        window.addEventListener('resize', function () {
          myChart.resize();
        });
      },
    },
  };
</script>
